import { useEffect, useState } from "react";
import { useUserInfor } from "../../../../Context/User";
import { useFiresbaseQuery } from "../../../../hooks/useFirebaseQuery";
import { getUsuariosOnlineCRMV2Ref } from "../../../../Services/Config/ConfigFirebaseCliente";
import { IUsuarioOnline } from "../../../../Interfaces/Users/UserOnline/UserOnlineInterfaces";

export default function UsuariosOnline() {
    const [lstUsuarios, setlstUsuarios] = useState([] as Array<IUsuarioOnline>);
    const { OrgInfor } = useUserInfor();
    const { value: Usuarios } = useFiresbaseQuery<IUsuarioOnline>(
        getUsuariosOnlineCRMV2Ref(OrgInfor.ID_ORGANIZACAO)
    );

    function updateList() {
        const UsuariosOnline = Usuarios?.filter((u) => u.CONEXOES);
        setlstUsuarios(UsuariosOnline ?? []);
    }

    useEffect(() => {
        updateList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Usuarios]);

    return (
        <div className="card card-custom h-100">
            <div className="card-header align-items-center  justify-content-center">
                <div className="text-center flex-grow-1">
                    <div className="text-dark-75 font-weight-bold font-size-h5">
                        Usuarios Online - {lstUsuarios.length}
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className="scroll scroll-pull scrollPerso ">
                    {lstUsuarios
                        ?.sort((a, b) =>
                            a.DS_NOME.localeCompare(b.DS_NOME, "es", {
                                sensitivity: "base",
                            })
                        )
                        .map((userOn) => (
                            <div
                                key={userOn.ID_USUARIO}
                                className="d-flex align-items-center justify-content-between mt-5"
                            >
                                <div className="d-flex align-items-center">
                                    <span className="symbol symbol-35 mr-3">
                                        <span className="symbol-label font-size-h5 font-weight-bold text-dark bg-dark-o-30 text-uppercase">
                                            {userOn.DS_NOME.substring(0, 1)}
                                        </span>
                                        <i className="symbol-badge bg-success"></i>
                                    </span>
                                    <div className="d-flex flex-column">
                                        {/* <span className="text-dark opacity-50 font-weight-bold font-size-sm d-none d-sm-inline">{userOn.DS_NOME}</span> */}
                                        <span className="text-dark-75 text-hover-primary font-weight-bold font-size-sm">
                                            {userOn.DS_NOME}
                                        </span>
                                        <span className="text-muted font-weight-bold font-size-sm">
                                            Cargo - Em Produção
                                        </span>
                                    </div>
                                </div>
                                <div className="d-flex flex-column align-items-end">
                                    <div className="d-flex flex-column align-items-end">
                                        <span className="text-muted font-weight-bold font-size-sm">
                                            Em Produção
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
}
